var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3939 6.25105C12.0591 6.58579 12.0591 7.1285 12.3939 7.46323L16.0737 11.143H4.42857C3.95518 11.143 3.57143 11.5268 3.57143 12.0002C3.57143 12.4736 3.95518 12.8573 4.42857 12.8573H16.0733L12.3939 16.5368C12.0591 16.8715 12.0591 17.4142 12.3939 17.749C12.7286 18.0837 13.2713 18.0837 13.6061 17.749L18.7375 12.6175C18.8993 12.4616 19 12.2426 19 12.0002C19 11.8993 18.9826 11.8024 18.9505 11.7125C18.9092 11.5962 18.842 11.487 18.7489 11.3939L13.6061 6.25105C13.2713 5.91632 12.7286 5.91632 12.3939 6.25105Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight1);
export default __webpack_public_path__ + "static/media/arrow-right-1.8699390f632a48e15646f4853abf5642.svg";
export { ForwardRef as ReactComponent };